import React, {Component} from 'react';
import DataFormat from "../../../../../../utilities/DateAndTimeFormat";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";

export default class PokazRozkladPrzystankiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    formatGodzina(cell, row) {
        return DataFormat.formatHHMM(cell)
    }

    render() {

        const options = {
            sizePerPage: 30,
            sizePerPageList: [10, 15, 30, 50, 100],
            defaultSortName: 'kolej',
            sortOrder: 'asc',
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination={false}
                                hover
                >
                    <TableHeaderColumn dataField='idRj' isKey
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={(cell, row) => {
                                           return cell
                                       }}
                    >ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='kolej'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Kolej</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwaMi'
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Miejscowość</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwaPr'
                                       thStyle={tabgrid.tg9} tdStyle={tabgrid.tg9}
                    >Przystanek</TableHeaderColumn>
                    <TableHeaderColumn dataField='godzPr'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatGodzina}
                    >Godzina</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/pokazRozklad/components/PokazRozkladPrzystankiTable.js